import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getPendingAuthorProfiles, approveAuthorProfile, rejectAuthorProfile } from "../user-settings-actions.js";
import PendingAuthorProfiles from '../components/pending-author-profiles.jsx';


class AuthorProfileApprovalsView extends Component {
  componentDidMount() {
    if (!localStorage.getItem('accessToken')) {
      this.props.history.push("/login-home/login");
    }
  }

  render() {
    return (
      <PendingAuthorProfiles
        getPendingProfiles={this.props.getPendingAuthorProfiles}
        onApprove={this.props.approveAuthorProfile}
        onReject={this.props.rejectAuthorProfile}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getPendingAuthorProfiles: () => dispatch(getPendingAuthorProfiles()),
    approveAuthorProfile: (id) => dispatch(approveAuthorProfile(id)),
    rejectAuthorProfile: (id, feedback) => dispatch(rejectAuthorProfile(id, feedback)),
  };
};

export default withRouter(connect(null, mapDispatchToProps)(AuthorProfileApprovalsView));
